export class Qualification {
    id : number;
    qualificationCode : string;
    qualificationName : string;
    qualifications : number;
}